export const navItems = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Gallery", path: "/gallery" },
  { label: "Testimonials", path: "/testimonials" },
  { label: "Blog", path: "/blog" },
  { label: "Contact Us", path: "/contact", cta: true },
];

export const services = [
  {
    id: "makeup",
    name: "Makeup",
    tagline: "Artistry in Every Stroke",
    desc: "From luminous bridal looks to editorial edge, our artists sculpt your perfect face.",
    image: "https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?w=1000&auto=format&fit=crop&q=74",
    treatments: ["Bridal Makeup", "HD & Airbrush", "Party Glam", "Photoshoot Looks"],
  },
  {
    id: "hair",
    name: "Hair",
    tagline: "Your Crown, Perfected",
    desc: "Cut, colour, and transform. Our stylists craft hair stories that turn heads.",
    image: "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=1000&auto=format&fit=crop&q=74",
    treatments: ["Cuts & Styling", "Colour & Balayage", "Smoothening", "Hair Spa"],
  },
  {
    id: "skin",
    name: "Skin",
    tagline: "Reveal Your Radiance",
    desc: "Advanced facials and clinical treatments tailored to unlock your skin's full potential.",
    image: "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=1000&auto=format&fit=crop&q=74",
    treatments: ["Signature Facials", "Anti-Ageing", "Tan Removal", "Brightening"],
  },
  {
    id: "spa",
    name: "Spa",
    tagline: "Surrender to Stillness",
    desc: "Ritual therapies and body journeys that restore you from the inside out.",
    image: "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=1000&auto=format&fit=crop&q=74",
    treatments: ["Body Massage", "Aromatherapy", "Deep Tissue", "Foot Reflexology"],
  },
  {
    id: "nails",
    name: "Nails",
    tagline: "Ten Tiny Canvases",
    desc: "Nail art so precise it's wearable sculpture - gel, acrylic, or natural.",
    image: "https://images.unsplash.com/photo-1604654894610-df63bc536371?w=1000&auto=format&fit=crop&q=74",
    treatments: ["Gel & Acrylic", "Nail Art", "Manicure & Pedi", "Nail Repair"],
  },
  {
    id: "academy",
    name: "Academy",
    tagline: "Turn Passion into Profession",
    desc: "Industry-led certifications that launch careers. Learn from masters, become one.",
    image: "https://images.unsplash.com/photo-1509631179647-0177331693ae?w=1000&auto=format&fit=crop&q=74",
    treatments: ["Makeup Artist Course", "Hair Dressing", "Skin Care", "Nail Tech"],
  },
];

export const gallery = [
  { src: "https://images.unsplash.com/photo-1519415510236-718bdfcd89c8?w=1000&auto=format&fit=crop&q=74", label: "Bridal Makeover" },
  { src: "https://images.unsplash.com/photo-1502823403499-6ccfcf4fb453?w=1000&auto=format&fit=crop&q=74", label: "Hair Styling" },
  { src: "https://images.unsplash.com/photo-1616394584738-fc6e612e71b9?w=1000&auto=format&fit=crop&q=74", label: "Nail Art" },
  { src: "https://images.unsplash.com/photo-1560869713-7d0a29430803?w=1000&auto=format&fit=crop&q=74", label: "Spa Ritual" },
  { src: "https://images.unsplash.com/photo-1521590832167-7bcbfaa6381f?w=1000&auto=format&fit=crop&q=74", label: "Skin Treatment" },
  { src: "https://images.unsplash.com/photo-1512290923902-8a9f81dc236c?w=1000&auto=format&fit=crop&q=74", label: "Salon Interior" },
];

export const testimonials = [
  { name: "Priya Sharma", role: "Bridal Client", rating: "5.0", text: "I walked in nervous and walked out feeling like a goddess. The bridal makeup was everything I dreamed of and more. My family couldn't stop complimenting the artists.", avatar: "P" },
  { name: "Ananya Reddy", role: "Regular Client", rating: "5.0", text: "My hair colour lasts longer than anywhere else in Bangalore. The balayage they did for me has literally made me famous among my friends. I won't go anywhere else.", avatar: "A" },
  { name: "Meena Krishnan", role: "Spa Client", rating: "5.0", text: "The deep tissue massage here undid three months of office stress in 90 minutes. The ambience, the oils, the pressure - everything was perfect. A true sanctuary.", avatar: "M" },
  { name: "Rashida Begum", role: "Academy Graduate", rating: "5.0", text: "I enrolled in the makeup artist course not knowing what to expect. Six months later I'm running my own freelance studio. Orchid Academy changed my life.", avatar: "R" },
  { name: "Divya Nair", role: "Nail Client", rating: "5.0", text: "Their nail art is genuinely gallery-worthy. I show pictures to people and they assume it's from Dubai or Mumbai. Right here in Bengaluru, exceptional work.", avatar: "D" },
];

export const blogs = [
  { tag: "Makeup", title: "Glass Skin Makeup: The 2025 Bridal Revolution", excerpt: "Dewy, luminous, and impossibly fresh - here's how our artists are redefining the Indian bridal look this season.", image: "https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?w=900&auto=format&fit=crop&q=74", date: "May 2025" },
  { tag: "Hair Care", title: "Why Your Hair Colour Fades (And How We Fix It)", excerpt: "Colour longevity is science, not luck. Our senior stylists break down the chemistry and what we do differently.", image: "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=900&auto=format&fit=crop&q=74", date: "Apr 2025" },
  { tag: "Skin Wellness", title: "One Facial a Month: The Habit That Transforms Skin", excerpt: "Monthly facials aren't luxury - they're maintenance. Here's the dermatologist-backed case for regular skin care.", image: "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=900&auto=format&fit=crop&q=74", date: "Apr 2025" },
];

export const marqueeItems = [
  "Makeup",
  "Bridal Makeup",
  "HD & Airbrush",
  "Hair",
  "Colour & Balayage",
  "Skin",
  "Signature Facials",
  "Spa",
  "Aromatherapy",
  "Nails",
  "Academy",
  "Ladies Only",
];
